import New from './WithdrawsNew'

const Withdraws = {
  New,
}

export default Withdraws
